
import styles from './YouTube.module.css'

type YouTubeProps = {
  videoUrl: string
  title?: string
}

function YouTube({ videoUrl, title }: YouTubeProps) {
  // Extract video ID from YouTube URL
  const getVideoId = (url: string): string | null => {
    const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/
    const match = url.match(regExp)
    return (match && match[2].length === 11) ? match[2] : null
  }

  const videoId = getVideoId(videoUrl)

  if (!videoId) {
    return (
      <div className={styles.error}>
        <p>Invalid YouTube URL. Please provide a valid YouTube video URL.</p>
      </div>
    )
  }

  return (
    <div className={styles.container}>
      {title && (
        <h3 className={styles.title}>{title}</h3>
      )}
      <div className={styles.videoWrapper}>
        <iframe
          className={styles.video}
          src={`https://www.youtube.com/embed/${videoId}`}
          title={title || 'YouTube video'}
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        />
      </div>
    </div>
  )
}

export { YouTube } 